import { render, staticRenderFns } from "./InternalCrisis.vue?vue&type=template&id=36e859b2&scoped=true&"
import script from "./InternalCrisis.vue?vue&type=script&lang=js&"
export * from "./InternalCrisis.vue?vue&type=script&lang=js&"
import style0 from "./InternalCrisis.vue?vue&type=style&index=0&id=36e859b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e859b2",
  null
  
)

export default component.exports